import { render, staticRenderFns } from "./DeleteClient.vue?vue&type=template&id=11b88e57&"
import script from "./DeleteClient.vue?vue&type=script&lang=js&"
export * from "./DeleteClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports